<div class="page">
  <div class="card fade-up" *ngIf="session">

    <!-- Lightweight brand header -->
    <div class="hud-brand-wrap">
      <div class="hud-brand">
        🚀 PSS Companion
        <button class="hud-info-btn" (click)="toggleInfoFlyout($event)" title="About this app" aria-label="About this app">ℹ</button>
        <div class="hud-info-flyout" *ngIf="infoFlyoutOpen">
          <p>Thank you for using my app. You can support this project <a href="https://buymeacoffee.com/lordtrist" target="_blank" rel="noopener noreferrer">here</a></p>
          <p>Please provide feedback or bugs on our <a href="https://discord.gg/upeuZmhu6r" target="_blank" rel="noopener noreferrer">discord</a>.</p>
        </div>
      </div>
      <div class="hud-brand-subtitle">by <span class="hud-brand-red">Lord Trist</span> of the <a class="hud-brand-link hud-brand-red" href="https://discord.gg/redbarons" target="_blank" rel="noopener noreferrer">Red Barons</a></div>
    </div>

    <!-- Pilot banner -->
    <div class="pilot-block" [ngClass]="rankTierClass">
      <div class="pilot-avatar" [ngClass]="{ 'pilot-avatar-badge': hasPilotBadge }">
        <ng-container *ngIf="hasPilotBadge">
          <span class="pilot-badge frame" *ngIf="pilotFrame" title="Frame: {{ pilotFrame }}">🖼️{{ pilotFrame }}</span>
          <span class="pilot-badge pin" *ngIf="pilotPin" title="Pin: {{ pilotPin }}">📌{{ pilotPin }}</span>
          <span class="pilot-badge ribbon" *ngIf="pilotRibbon" title="Ribbon: {{ pilotRibbon }}">🎗️{{ pilotRibbon }}</span>
        </ng-container>
        <ng-container *ngIf="!hasPilotBadge">
          {{ session.name[0] | uppercase }}
        </ng-container>
      </div>
      <div class="pilot-details">
        <div class="pilot-name-row">
          <span class="pilot-name">{{ details?.name || session.name }}</span>
          <pss-sprite *ngIf="leagueIconSpriteId" [spriteId]="leagueIconSpriteId" class="pilot-league-icon" [alt]="leagueName + ' league icon'"></pss-sprite>
          <img *ngIf="!leagueIconSpriteId && leagueIconFallbackUrl" [src]="leagueIconFallbackUrl" class="pilot-league-icon" alt="{{ leagueName }} league icon" />
          <span *ngIf="details && !loading" class="pilot-league" [ngClass]="leagueCssClass">{{ leagueName }}</span>
          <button class="btn-switch-account" (click)="switchAccount()" title="switch accounts">⇄</button>
          <button *ngIf="automationFeatureEnabled" class="btn btn-ghost btn-automation" (click)="openAutomationModal()" title="Automation settings">
            <span class="btn-icon-zap" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <polyline points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </button>
          <button *ngIf="isAdmin" class="btn btn-ghost btn-admin" (click)="goToAdmin()" title="Admin panel">Admin</button>
          <span class="pilot-name-spacer"></span>
          <button class="btn-support btn-support-tooltip" (click)="openSupportPage()" data-tooltip="Thank you for supporting me and keeping this app ad free" aria-label="Thank you for supporting me and keeping this app ad free">Tip Jar</button>
        </div>
        <div class="pilot-meta">
          Ship Level {{ details?.shipLevel || session.shipLevel }}
          <span *ngIf="details?.fleetName && details?.fleetName !== '\u2014'">
            &nbsp;·&nbsp;{{ details?.fleetName }}
            <span class="fleet-rank">({{ details?.fleetMembership }})</span>
          </span>
          <span *ngIf="!details?.fleetName || details?.fleetName === '\u2014'">&nbsp;·&nbsp;No Fleet</span>
        </div>
        <div class="pilot-stats" *ngIf="details && !loading">
          <span class="pilot-stat">🏆 {{ formatNumber(details.trophies) }}</span>
          <span *ngIf="details.globalRanking" class="pilot-stat pilot-rank" [ngClass]="rankTierClass" (click)="toggleRankHistory()" title="Click to view rank history">
            🏅 {{ rankLabel }}
            <span *ngIf="rankSource === 'cache'" class="pilot-rank-source">(cached)</span>
            <span *ngIf="rankSource === 'live'" class="pilot-rank-source">(live)</span>
          </span>
          <span class="pilot-stat-dim" title="Personal best">(max: {{ formatNumber(details.highestTrophy) }})</span>
          <span class="pilot-stat-sep">·</span>
          <span class="pilot-stat">⚡ {{ formatNumber(details.powerScore) }}</span>
        </div>
        <div class="pilot-rank-history" *ngIf="rankHistoryOpen">
          <div class="pilot-rank-history-header">Ranking history</div>
          <div *ngIf="rankHistoryLoading" class="pilot-rank-history-loading">Loading rank history…</div>
          <div *ngIf="!rankHistoryLoading && rankHistory.length > 0" class="pilot-rank-history-list">
            <div class="pilot-rank-history-row" *ngFor="let row of rankHistory">
              <span class="history-date">{{ row.recordedAt | date:'MMM d, y HH:mm' }}</span>
              <span class="history-rank">#{{ row.ranking }}</span>
              <span class="history-meta">Users: {{ row.totalUsers || '—' }} | Active: {{ row.totalActiveUsers || '—' }}</span>
            </div>
          </div>
          <div *ngIf="!rankHistoryLoading && rankHistory.length === 0" class="pilot-rank-history-empty">No stored rank history yet.</div>
        </div>
        <div class="pilot-daily-trophies" *ngIf="details && !loading" title="Daily PVP trophy movement by UTC day">
          <div class="pilot-daily-counts" role="button" tabindex="0" (click)="openBattlesTab()" (keyup.enter)="openBattlesTab()" aria-label="Open battle log for this UTC day">
            <span class="pilot-daily-key">PVP</span>
            <span class="pilot-daily-key">Won</span>
            <span class="pilot-daily-pos">{{ dailyTrophySummary.positive }}</span>
            <span class="pilot-daily-key">Lost</span>
            <span class="pilot-daily-neg">{{ dailyTrophySummary.negative }}</span>
            <span class="pilot-daily-key">Bal</span>
            <span
              [ngClass]="{
                'pilot-daily-pos': dailyTrophySummary.balance > 0,
                'pilot-daily-neg': dailyTrophySummary.balance < 0,
                'pilot-daily-even': dailyTrophySummary.balance === 0
              }"
            >
              {{ dailyTrophySummary.balance > 0 ? '+' : '' }}{{ dailyTrophySummary.balance }}
            </span>
          </div>
          <div class="pilot-daily-picker">
            <button class="pilot-daily-nav" (click)="$event.stopPropagation(); prevUtcDay()" title="Previous UTC day">&lt;</button>
            <span class="pilot-daily-date">{{ viewedUtcDateLabel }}</span>
            <button class="pilot-daily-nav" (click)="$event.stopPropagation(); nextUtcDay()" [disabled]="!canViewNewerUtcDay" title="Next UTC day">&gt;</button>
          </div>
        </div>
        <div class="support-strip" *ngIf="hasSupporterBadge">
          <span class="support-badge">Thanks for your support</span>
        </div>
      </div>
    </div>

    <!-- Loading state -->
    <div class="loading-block" *ngIf="loading">
      <span class="spinner"></span> Loading pilot data...
    </div>

    <!-- Soft error -->
    <div class="error-msg" *ngIf="error && !loading">{{ error }}</div>

    <!-- Stats grid -->
    <div class="stats-section" *ngIf="details && !loading">

      <app-dashboard-nav
        [activeTab]="activeTab"
        [crewCount]="details.crew.length"
        [roomsCount]="deployedRooms.length"
        [battlesCount]="battles.length"
        [inventoryCount]="details.inventory.length"
        [pendingFriendCount]="pendingFriendCount"
        [hasGalaxy]="details.starSystemDetails.length > 0"
        [hasAlliance]="!!details.allianceId"
        [hasTournamentAnalysis]="hasTournamentAnalysis"
        (tabSelect)="onDashboardTabSelect($event)"
        (refreshClicked)="onManualRefresh()"
        [refreshing]="loading">
      </app-dashboard-nav>

      <!-- ── Overview ── -->
      <app-overview-tab *ngIf="activeTab === 'overview'"
        [details]="details"
        [session]="session"
        [enableBoostUi]="canSeeBoostFeature"
        [boostGauge]="boostGauge"
        [rushTargets]="boostTargetsForModal"
        (useBoost)="openBoostModal()">
      </app-overview-tab>

      <!-- ── Crew ── -->
      <app-crew-tab *ngIf="activeTab === 'crew' && details.crew.length > 0"
        [details]="details"
        [characterDesigns]="characterDesigns"
        [roomDesigns]="roomDesigns"
        (crewSelected)="selectCrew($event)">
      </app-crew-tab>

      <!-- ── Rooms ── -->
      <app-rooms-tab *ngIf="activeTab === 'rooms' && details.rooms.length > 0"
        [details]="details"
        [roomDesigns]="roomDesigns"
        [shipDesigns]="shipDesigns"
        (roomSelected)="selectRoom($event)">
      </app-rooms-tab>

      <!-- ── Galaxy ── -->
      <app-galaxy-tab *ngIf="activeTab === 'galaxy' && details.starSystemDetails.length > 0"
        [details]="details"
        [starSystems]="starSystems">
      </app-galaxy-tab>

      <!-- ── Fleet ── -->
      <app-fleet-tab *ngIf="activeTab === 'fleet' && details.allianceId"
        [session]="session"
        [details]="details">
      </app-fleet-tab>

      <!-- ── Fleet Chat ── -->
      <app-fleet-chat-tab *ngIf="activeTab === 'fleet-chat' && details.allianceId"
        [session]="session"
        [details]="details">
      </app-fleet-chat-tab>

      <!-- ── Friends ── -->
      <app-friends-tab *ngIf="activeTab === 'friends'"
        [session]="session"
        (pendingCount)="pendingFriendCount = $event">
      </app-friends-tab>

      <!-- ── Battles ── -->
      <app-battles-tab *ngIf="activeTab === 'battles'"
        [battles]="battles"
        [loading]="battlesLoading"
        [error]="battlesError"
        [userId]="session.userId"
        [allianceId]="details.allianceId">
      </app-battles-tab>

      <!-- ── Inventory ── -->
      <app-inventory-tab *ngIf="activeTab === 'inventory'"
        [details]="details"
        [itemDesigns]="itemDesigns"
        [characterDesigns]="characterDesigns"
        [roomDesigns]="roomDesigns"
        [invNewItems]="invNewItems"
        (useItemRequested)="openUseItemModal($event)">
      </app-inventory-tab>

      <!-- ── Tournament ── -->
      <app-tournament-tab
        *ngIf="activeTab === 'tournament' && hasTournamentAnalysis && details.allianceId"
        [session]="session"
        [details]="details">
      </app-tournament-tab>

    </div>

  </div>
</div>

<app-automation-modal
  [show]="showAutomationModal"
  [automationFeatureEnabled]="automationFeatureEnabled"
  [automationError]="automationError"
  [autoTaskSaving]="autoTaskSaving"
  [autoEnableBattleSync]="autoEnableBattleSync"
  [autoEnableDonationExtend]="autoEnableDonationExtend"
  [autoDonationSelectedIds]="autoDonationSelectedIds"
  [autoScheduleType]="autoScheduleType"
  [autoIntervalSec]="autoIntervalSec"
  [autoCronExpression]="autoCronExpression"
  [autoScheduleTimes]="autoScheduleTimes"
  [autoScheduleTimeInput]="autoScheduleTimeInput"
  [donatedCrew]="donatedCrew"
  [characterDesigns]="characterDesigns"
  (close)="closeAutomationModal()"
  (save)="saveAutomationSettings()"
  (setAutoEnableBattleSync)="autoEnableBattleSync = $event"
  (setAutoEnableDonationExtend)="autoEnableDonationExtend = $event"
  (toggleDonationSelection)="toggleDonationSelection($event.characterId, $event.selected)"
  (setAutoScheduleType)="autoScheduleType = $event"
  (setAutoIntervalSec)="autoIntervalSec = $event"
  (setAutoCronExpression)="autoCronExpression = $event"
  (setAutoScheduleTimeInput)="autoScheduleTimeInput = $event"
  (addScheduleTime)="addScheduleTime()"
  (removeScheduleTime)="removeScheduleTime($event)">
</app-automation-modal>

<app-crew-detail-modal
  [crew]="selectedCrew"
  [characterDesigns]="characterDesigns"
  [itemDesigns]="itemDesigns"
  [inventory]="details?.inventory || []"
  [rules]="selectedCrewAI"
  [conditionTypes]="conditionTypeList()"
  [actionTypes]="actionTypeList()"
  [showAi]="showCrewAI"
  [aiSaving]="aiSaving"
  [aiError]="aiError"
  [compareAiSaving]="compareAiSaving"
  [compareAiError]="compareAiError"
  [initialConditionId]="aiNewConditionId"
  [initialActionId]="aiNewActionId"
  [compareTargets]="compareCrewTargets"
  [userId]="session?.userId || ''"
  [allianceId]="details?.allianceId || ''"
  [userName]="session?.name || ''"
  (close)="closeCrew()"
  (toggleAi)="showCrewAI = !showCrewAI"
  (addRule)="handleCrewAiAdd($event)"
  (deleteRule)="deleteAIRule($event)"
  (moveRule)="moveCrewAIRule($event.rule, $event.newIndex)"
  (importRules)="importCrewAIRules($event)"
  (deleteAllRules)="deleteAllCrewAIRules()"
  (editRule)="handleCrewAiEdit($event)"
  (compareEditRule)="handleCompareCrewAiEdit($event)"
  (deleteAllCompareRules)="deleteAllCompareCrewAIRules($event)"
  (compareAddRule)="handleCompareCrewAiAdd($event)"
  (compareDeleteRule)="handleCompareCrewAiDelete($event)"
  (compareMoveRule)="handleCompareCrewAiMove($event)"
  (compareImportRules)="handleCompareCrewAiImport($event)"
  (copyFromCompare)="handleCrewAiCopyFromCompare($event)">
</app-crew-detail-modal>

<app-use-item-modal
  [item]="useItemModal"
  [itemDesigns]="itemDesigns"
  [characterDesigns]="characterDesigns"
  [inventory]="details?.inventory || []"
  [characters]="useItemCharacters"
  [count]="useItemCount"
  [maxCount]="useItemMaxCount()"
  [progress]="useItemProgress"
  [total]="useItemTotal"
  [running]="useItemRunning"
  [done]="useItemDone"
  [error]="useItemError"
  [retryMsg]="useItemRetryMsg"
  [results]="useItemResults"
  [groupedResults]="groupedUseItemResults"
  [grouped]="useItemResultsGrouped"
  [selectedReward]="useItemSelectedReward"
  [showFireOptions]="useItemSupportsFiring()"
  [fireCommon]="useItemFireCommon"
  [fireElite]="useItemFireElite"
  [firedCharacterIds]="useItemFiredIds"
  [supportUrl]="lastSupportUrl ?? 'https://buymeacoffee.com/lordtrist'"
  (close)="closeUseItemModal()"
  (start)="startUseItems()"
  (countChange)="useItemCount = $event"
  (groupedChange)="useItemResultsGrouped = $event"
  (selectedRewardChange)="useItemSelectedReward = $event"
  (fireCommonChange)="useItemFireCommon = $event"
  (fireEliteChange)="useItemFireElite = $event">
</app-use-item-modal>

<app-room-detail-modal
  [room]="selectedRoom"
  [roomDesigns]="roomDesigns"
  [characterDesigns]="characterDesigns"
  [availableAmmo]="availableAmmo"
  [selectedAmmoId]="selectedAmmoId"
  [selectedRoomFireRate]="selectedRoomFireRate"
  [selectedRoomMinDps]="selectedRoomMinDps"
  [selectedRoomMaxDps]="selectedRoomMaxDps"
  [selectedRoomAdjacentAB]="selectedRoomAdjacentAB !== null"
  [selectedRoomAbBoost]="selectedRoomAbBoost"
  [selectedRoomStatLabel]="selectedRoomStatLabel"
  [selectedRoomCrewBoost]="selectedRoomCrewBoost"
  [selectedRoomCrew]="selectedRoomCrew"
  [selectedRoomStatKey]="selectedRoomStatKey"
  [itemDesigns]="itemDesigns"
  [inventory]="details?.inventory || []"
  [roomHasStatBoost]="selectedRoom ? roomHasStatBoost(selectedRoom.roomDesignId) : false"
  (selectCrew)="selectCrew($event)"
  [rules]="selectedRoomAI"
  [conditionTypes]="conditionTypeList()"
  [actionTypes]="actionTypeList()"
  [aiItems]="selectedRoomAiItems"
  [roomAiSaving]="roomAiSaving"
  [roomAiError]="roomAiError"
  [initialConditionId]="roomAiNewConditionId"
  [initialActionId]="roomAiNewActionId"
  [userId]="session?.userId || ''"
  [allianceId]="details?.allianceId || ''"
  [userName]="session?.name || ''"
  (close)="closeRoom()"
  (selectedAmmoIdChange)="selectedAmmoId = $event"
  (addRule)="handleRoomAiAdd($event)"
  (deleteRule)="deleteRoomAIRule($event)"
  (moveRule)="moveRoomAIRule($event.rule, $event.newIndex)"
  (importRules)="importRoomAIRules($event)"
  (deleteAllRules)="deleteAllRoomAIRules()"
  (editRule)="handleRoomAiEdit($event)">
</app-room-detail-modal>

<div class="boost-confetti-overlay" *ngIf="showBoostConfetti" aria-hidden="true">
  <div class="confetti-piece" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19]" [attr.data-i]="i"></div>
</div>

<div class="boost-modal-overlay" *ngIf="canSeeBoostFeature && showBoostModal" (click)="closeBoostModal()">
  <div class="boost-modal" (click)="$event.stopPropagation()">
    <div class="boost-modal-header">
      <div class="boost-modal-title">Use Boost Gauge</div>
      <button class="boost-modal-close" (click)="closeBoostModal()" [disabled]="boostApplying">✕</button>
    </div>

    <div class="boost-modal-body">
      <div class="boost-modal-msg" *ngIf="boostResultMsg && !boostError">{{ boostResultMsg }}</div>
      <div class="boost-modal-error" *ngIf="boostError">{{ boostError }}</div>

      <div class="boost-empty" *ngIf="boostTargetsForModal.length === 0">
        No active room or research upgrades found right now.
      </div>

      <div class="boost-target-list" *ngIf="boostTargetsForModal.length > 0">
        <button
          class="boost-target"
          *ngFor="let target of boostTargetsForModal"
          [class.active]="selectedRushTargetId === (target.targetType + ':' + target.targetId)"
          (click)="selectRushTarget(target)">
          <pss-sprite *ngIf="boostTargetSprite(target)" class="boost-target-sprite" [spriteId]="boostTargetSprite(target)"></pss-sprite>
          <div class="boost-target-meta">
            <span class="boost-target-label">{{ boostTargetTitle(target) }}</span>
            <span class="boost-target-subtitle">{{ boostTargetSubtitle(target) }}</span>
          </div>
        </button>
      </div>
    </div>

    <div class="boost-modal-footer">
      <button class="btn btn-ghost" (click)="closeBoostModal()" [disabled]="boostApplying">Cancel</button>
      <button class="btn btn-warning" (click)="applyBoostToSelected()" [disabled]="boostApplying || !canApplyBoost">
        {{ boostApplying ? 'Applying…' : 'Apply Boost' }}
      </button>
    </div>
  </div>
</div>
